import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import ReactList from 'react-list'
import styled from 'styled-components'
import get from 'lodash/get'
import set from 'lodash/set'
import find from 'lodash/find'
import orderBy from 'lodash/orderBy'
import moment from '../../../../lib/moment.js'
import shortid from 'shortid'
import arrow_down from '../../../../static/images/arrow-down.svg'
import arrow_up from '../../../../static/images/arrow-up.svg'
import { lob_overview_table } from '../../constants'
import { FONTS } from '../../../../constants'

export default class LOBOverviewTable extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    const efficiencyResources = get(nextProps, 'efficiencyResources', [])
    if (JSON.stringify(efficiencyResources) !== JSON.stringify(prevState.efficiencyResources)
    || get(nextProps, 'lobOverview') !== prevState.lobOverview) {
      const lobs = get(nextProps, 'lobs')
      let resources = efficiencyResources.map(res => {
        const newRes = res
        const lob = find(lobs, {
          _id: res.lob_id,
        })
        newRes.lob_name = lob ? lob.name : '-'
        return newRes
      })
      if (get(nextProps, 'lobOverview') !== '') {
        resources = resources.filter(res => {
          return res.lob_id === get(nextProps, 'lobOverview')
        })
      }
      const sortOrder = 'desc'
      const sortColumn = [
        (item) => {
          const order = {
            false: 1,
            true: 2,
          }
          return order[item.is_submited]
        },
        'month',
        'month',
        'lob_name',
        'submit_date',
        'updated_by',
      ]
      const list = orderBy(resources, sortColumn[prevState.sort_column], sortOrder)
      set(tempState, 'efficiencyResources', efficiencyResources)
      set(tempState, 'lobOverview', get(nextProps, 'lobOverview'))
      set(tempState, 'lobs', lobs)
      set(tempState, 'items', [...list])
    }
    return tempState
  }

  state={
    sort_order: false,
    sort_column: 0,
    lobOverview: '',
    efficiencyResources: [],
    items: [],
  }

  handleClickSort = (column) => {
    let { sort_order } = { ...this.state }
    const { efficiencyResources } = this.state

    if (column === this.state.sort_column) {
      sort_order = !this.state.sort_order
      this.setState({
        sort_order: !this.state.sort_order,
      })
    } else {
      sort_order = false
      this.setState({
        sort_order: false,
        sort_column: column,
      })
    }
    sort_order = sort_order ? 'asc' : 'desc'
    const sortColumn = [
      (item) => {
        const order = {
          false: 1,
          true: 2,
        }
        return order[item.is_submited]
      },
      'month',
      'month',
      'lob_name',
      'submit_date',
      'updated_by',
    ]
    let newItems = orderBy(efficiencyResources, sortColumn[column], sort_order)
    if (this.state.lobOverview !== '') {
      newItems = newItems.filter(item => {
        return item.lob_id === this.state.lobOverview
      })
    }
    this.setState({ items: newItems })
  }

  renderItem = (index) => {
    const users = get(this.props, 'users', [])
    const data = this.state.items[index]
    const user = find(users, {
      _id: data.updated_by,
    })
    return (
      <tr
        key={ shortid() }
        style={ {
          cursor: data.is_submited ? 'pointer' : '',
          hover: '#E5E5E5',
        } }
        onClick={ () => {
          if (data.is_submited) this.props.clickRow(data)
        } }
      >
        <td>
          <div
            style={ {
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              color: data.is_submited ? '#5CB85C' : '#CCCCCC',
            } }
          >
            <Circle color={ data.is_submited ? '#5CB85C' : '#CCCCCC' } />
            <span>{ data.is_submited ? 'Submitted' : 'Unsubmitted' }</span>
          </div>
        </td>
        <td>{ moment(data.month).format('MMMM') }</td>
        <td>{ moment(data.month).format('YYYY') }</td>
        <td>{ data.lob_name }</td>
        <td>{ data.submit_date ? moment(data.submit_date).format('DD/MM/YYYY') : '-' }</td>
        <td>{ user ? `${get(user, 'first_name')} ${get(user, 'last_name')} (${get(user, 'nick_name')})` : '-' }</td>
      </tr>
    )
  }

  render() {
    const { sort_order, sort_column, items } = this.state

    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <CustomTable bordered hover>
          <Header>
            <tr style={ { fontFamily: 'Gotham' } }>
              { lob_overview_table.map((h) =>
                (<HeadTable key={ shortid() } onClick={ () => this.handleClickSort(h.value) } >
                  { h.label }
                  { h.value === sort_column && (
                    sort_order && h.value === sort_column ?
                      <Icon src={ arrow_up } alt="logo" />
                      :
                      <Icon src={ arrow_down } alt="logo" />
                  )
                  }</HeadTable>)
              )}
            </tr>
          </Header>
          <BodyTable>
            <ReactList
              itemRenderer={ this.renderItem }
              length={ items.length }
            />
          </BodyTable>
        </CustomTable>
      </Wrapper>
    )
  }
}

LOBOverviewTable.propTypes = {
  clickRow: PropTypes.func,
}
LOBOverviewTable.defaultProps = {
  clickRow: () => {},
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
`
const CustomTable = styled(Table)`
  background: white;
  thead {
    display:table;
    width: 100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    background-color: #404040;
  } tbody tr {
    display:table;
    width: 100%;
    table-layout:fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border: none;
  } thead th {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
  } tbody td {
    border: 1px solid #dee2e6;
    font-size: ${FONTS.SMALL_SIZE};
    word-wrap: break-word;
  }
`
const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  max-height: calc(100vh - 200px);
  overflow-y:scroll;
  ::-webkit-scrollbar {
    display: none;
  }
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Icon = styled.img`
  height: 10px;
  margin-left: 5%;
  cursor: pointer;
`
const Header = styled.thead`
  background: black;
  color: white;
`
const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: ${props => { return props.color }};
  border-radius: 50%;
  margin-right: 8px;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-overview/table.js